import React, { Component } from 'react';
import qs from 'query-string';

import {
  hasIdTokenLocalStorage,
  getIdTokenLocalStorage,
  addIdTokenLocalStorage,
  isJwtValid,
} from './jwt';

const withSSO = configuration => BaseComponent => class WithSSO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authToken: null,
      renderApplication: false,
    };
  }

  componentDidMount() {
    this.authentication();
  }

  getTokenInUrl() {
    const url = qs.parseUrl(window.location.href);
    if ('token' in url.query) {
      return url.query.token;
    }
    return null;
  }

  authentication() {
    let token = null;

    token = this.getTokenInUrl();
    if (token && isJwtValid(token)) {
      addIdTokenLocalStorage(token);
      return this.setState({
        authToken: token,
        renderApplication: true,
      });
    }

    if (hasIdTokenLocalStorage()) {
      token = getIdTokenLocalStorage();
      if (isJwtValid(token)) {
        return this.setState({
          authToken: token,
          renderApplication: true,
        });
      }
    }

    return this.redirectSSO();
  }

  redirectSSO() {
    window.location.replace(configuration.redirectUrl);
  }

  render() {
    const { authToken, renderApplication } = this.state;
    if (renderApplication) {
      return <BaseComponent token={authToken} />;
    }

    return null;
  }
};

export default withSSO;
